import { FC } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IExportProductsParams } from '@app/models/interfaces';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { useExportProductsQuery } from '../../../../hooks';

interface IProps {
  params: IExportProductsParams;
}

export const ExportButton: FC<IProps> = ({ params }) => {
  const { token } = theme.useToken();
  const nomenclatureListT = useTranslation(NSKeys.nomenclatureList);
  const currentSession = useLocalSelector((state) => state.currentSession);

  const { mutate, status } = useExportProductsQuery();

  if (!currentSession.productsContext?.scope?.$permissions?.export_products) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={nomenclatureListT.t('exportTooltip')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate(params)}
      />
    </Tooltip>
  );
};
